import { render, staticRenderFns } from "./PddOrderDetail.vue?vue&type=template&id=cd72b8dc&scoped=true&"
import script from "./PddOrderDetail.vue?vue&type=script&lang=js&"
export * from "./PddOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd72b8dc",
  null
  
)

export default component.exports